export default __webpack_public_path__ + "static/media/icon-avatar-login.efce0996.svg";